import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_GET_CUT_OFF_HOUR } from 'constants/urls';

/**
 * Fetches the configured payroll cut-off hour.
 * @returns The API response data (cut-off hour value)
 * @throws Re-throws any Axios error after logging
 */
const getCutOffHour = async () => {
  try {
    const { data } = await axiosInstance.get(URL_CANTRACK_GET_CUT_OFF_HOUR);
    return data;
  } catch (error) {
    console.error('[getCutOffHour] Failed:', error);
    throw error;
  }
};

export default getCutOffHour;
